import { StoryblokLink } from '../useStoryblokLinks';
import { generateBreadcrumbTrail } from './generateBreadcrumbTrail';
import { createBreadcrumbSchema } from '../schemaHelpers';

/**
 * Generates a breadcrumb schema object for a given story.
 *
 * @param storyData - An object containing the full_slug or slug of the story.
 * @param links - An array of StoryblokLink objects representing all available links.
 * @returns A breadcrumb schema object that can be used for structured data,
 * or null if no valid slug is provided.
 */

export function getBreadcrumbSchema(
  storyData: { full_slug?: string; slug?: string },
  links: StoryblokLink[],
  baseUrl: string
): object | null {
  const normalizedSlug =
    storyData.full_slug?.replace(/\/$/, '') ?? storyData.slug;
  if (!normalizedSlug) return null;

  const relativeItems = generateBreadcrumbTrail(normalizedSlug, links);
  const absoluteItems = relativeItems.map((item) => ({
    name: item.name,
    url: new URL(item.url, baseUrl).toString(), // ensures absolute URL
  }));

  return createBreadcrumbSchema(absoluteItems);
}
